import { useParams } from 'react-router'
import { ActiveOrgCodeProvider } from 'shared-ui/active-operation'

export const ActiveOperationProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const { orgCode } = useParams()

  return <ActiveOrgCodeProvider orgCode={orgCode}>{children}</ActiveOrgCodeProvider>
}
